// removed by extract-text-webpack-plugin
module.exports = {"header":"_1YHxZ _2oaig _28zmO heezw _2oaig _28zmO","list":"_1gh8J x88Rx _2BXrS","list-wrapper":"_2ky3m x88Rx _2BXrS","empty":"_20My1 _1-OXK _3Xg8b _3ibIU _2k2oP","item":"a6P26 hhMuP _1-OXK _3Xg8b _1Q5o6","itemBody":"_2jwPJ _3_vf0","itemTitle":"zwby7 _1v96X","itemName":"_1PDl9 _2gWZX Md4ty","itemSubtitle":"_1lsIS","itemSubtitleBold":"pkI0n","open":"leiHH","tagIcon":"_1WNjl"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/List.css
// module id = 760
// module chunks = 3